import React, { useState } from "react";
import StudentHeader from "../components/StudentHeader";
import Footer from "../components/Footer";
import { Container, Card, Form, Row, Col, Button } from "react-bootstrap";
import {
    FaFolder,
    FaEye,
    FaTrashAlt,
    FaUndoAlt,
    FaRegCalendarAlt,
    FaRegClock,
} from "react-icons/fa";
import Calendar from "react-calendar";
import "react-calendar/dist/Calendar.css";
import { DataGrid } from "@mui/x-data-grid";
import Chip from "@mui/material/Chip";

const columns = [
    { field: "id", headerName: "ID", sortable: false, width: 70 },
    { field: "school", headerName: "School", sortable: false, width: 150 },
    { field: "hospital", headerName: "Hospital", sortable: false, width: 150 },
    {
        field: "department",
        headerName: "Department",
        sortable: false,
        width: 150,
    },
    {
        field: "date",
        headerName: "Date",
        sortable: false,
        width: 200,
    },
    {
        field: "hours",
        headerName: "Hours",
        sortable: false,
        width: 150,
    },
    {
        field: "status",
        headerName: "Approval Status",
        sortable: false,
        width: 150,
        renderCell: (params) => {
            return (
                <div
                    className="d-flex justify-content-between align-items-center"
                    style={{ cursor: "pointer" }}
                >
                    <Chip label="Under review" size="small" color="primary" />
                </div>
            );
        },
    },
    {
        field: "action",
        headerName: "Action",
        sortable: false,
        width: 150,
        renderCell: (params) => {
            return (
                <div
                    className="d-flex justify-content-between align-items-center"
                    style={{ cursor: "pointer" }}
                >
                    <Button
                        variant="success"
                        size="sm"
                        href="/hospital-dashboard"
                    >
                        Accept
                    </Button>{" "}
                    <Button variant="danger" size="sm" className="ms-2">
                        Reject
                    </Button>
                </div>
            );
        },
    },
];

const rows = [
    {
        id: 1,
        school: "lorem ipsum",
        hospital: "lorem ipsum",
        department: "lorem ipsum",
        date: "12/11/2022 -  18/11/2022",
        hours: "12 hours",
        status: "Under review",
    },
    {
        id: 2,
        school: "lorem ipsum",
        hospital: "lorem ipsum",
        department: "lorem ipsum",
        date: "12/11/2022 -  18/11/2022",
        hours: "12 hours",
        status: "Under review",
    },
    {
        id: 3,
        school: "lorem ipsum",
        hospital: "lorem ipsum",
        department: "lorem ipsum",

        date: "12/11/2022 -  18/11/2022",
        hours: "12 hours",
        status: "Under review",
    },
    {
        id: 4,
        school: "lorem ipsum",
        hospital: "lorem ipsum",
        department: "lorem ipsum",
        date: "12/11/2022 -  18/11/2022",
        hours: "12 hours",
        status: "Rejected",
    },
    {
        id: 5,
        school: "lorem ipsum",
        hospital: "lorem ipsum",
        department: "lorem ipsum",
        date: "12/11/2022 -  18/11/2022",
        hours: "12 hours",
        status: "Rejected",
    },

    {
        id: 6,
        school: "lorem ipsum",
        hospital: "lorem ipsum",
        department: "lorem ipsum",
        date: "12/11/2022 -  18/11/2022",
        hours: "12 hours",
        status: "Under review",
    },
    {
        id: 7,
        school: "lorem ipsum",
        hospital: "lorem ipsum",
        department: "lorem ipsum",
        date: "12/11/2022 -  18/11/2022",
        hours: "12 hours",
        status: "Under review",
    },
    {
        id: 8,
        school: "lorem ipsum",
        hospital: "lorem ipsum",
        department: "lorem ipsum",

        date: "12/11/2022 -  18/11/2022",
        hours: "12 hours",
        status: "Under review",
    },
    {
        id: 9,
        school: "lorem ipsum",
        hospital: "lorem ipsum",
        department: "lorem ipsum",
        date: "12/11/2022 -  18/11/2022",
        hours: "12 hours",
        status: "Rejected",
    },
    {
        id: 10,
        school: "lorem ipsum",
        hospital: "lorem ipsum",
        department: "lorem ipsum",
        date: "12/11/2022 -  18/11/2022",
        hours: "12 hours",
        status: "Rejected",
    },
    {
        id: 11,
        school: "lorem ipsum",
        hospital: "lorem ipsum",
        department: "lorem ipsum",
        date: "12/11/2022 -  18/11/2022",
        hours: "12 hours",
        status: "Rejected",
    },
    {
        id: 12,
        school: "lorem ipsum",
        hospital: "lorem ipsum",
        department: "lorem ipsum",
        date: "12/11/2022 -  18/11/2022",
        hours: "12 hours",
        status: "Rejected",
    },
    {
        id: 13,
        school: "lorem ipsum",
        hospital: "lorem ipsum",
        department: "lorem ipsum",
        date: "12/11/2022 -  18/11/2022",
        hours: "12 hours",
        status: "Rejected",
    },
];

const AdminApproval = () => {
    const [value, onChange] = useState(new Date());
    return (
        <div className="dashbrd_pg">
            <StudentHeader />
            <div className="schl_prfl_pg">
                <Container className="custm_container">
                    <div className="prfl_wrap">
                        <div className="pg_hdng mb-4">
                            <h2>Admin</h2>
                        </div>
                        <Row>
                            <Col sm={12}>
                                <Card className="pg_card">
                                    <Card.Body>
                                        <div className="card_hdng">
                                            <h4 className="mb-0">
                                                School Requests
                                            </h4>
                                        </div>
                                        <div className="apprvl_list">
                                            <div
                                                style={{
                                                    height: 400,
                                                    width: "100%",
                                                }}
                                            >
                                                <DataGrid
                                                    rows={rows}
                                                    rowCount={15}
                                                    paginationMode="server"
                                                    columns={columns}
                                                    pagination
                                                    onPageChange={(newPage) =>alert(newPage)}
                                                    pageSize={5}
                                                    rowsPerPageOptions={[5]}
                                                />
                                            </div>
                                        </div>
                                    </Card.Body>
                                </Card>
                            </Col>
                        </Row>
                    </div>
                </Container>
            </div>
            <Footer />
        </div>
    );
};

export default AdminApproval;
